var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page forbit-cancel-tree" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "50%",
            "mask-closable": false,
            "footer-hide": true,
            title:
              _vm.areaType === 0
                ? _vm.$t("newarea.add")
                : _vm.$t("newarea.edit"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _vm.spinShow
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modalContainer modalHeight" },
            [
              _c(
                "Form",
                {
                  ref: "addForm",
                  attrs: {
                    "label-width": 150,
                    model: _vm.addForm,
                    "label-colon": "",
                    rules: _vm.ruleValidateSingleAddArea,
                  },
                },
                [
                  _vm.addForm.namePath && _vm.addForm.level != 1
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            label: _vm.$t("deviceSip.prevArea"),
                            prop: "namePath",
                            required: "",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              size: "large",
                              type: "textarea",
                              autosize: { minRows: 1, maxRows: 5 },
                              clearable: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.addForm.namePath,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "namePath", $$v)
                              },
                              expression: "addForm.namePath",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "FormItem",
                    { attrs: { prop: "name", label: _vm.$t("area.areaName") } },
                    [
                      _c("Input", {
                        attrs: {
                          size: "large",
                          maxlength: 20,
                          placeholder: _vm.$t("area.areaNameHold"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.addForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "name", $$v)
                          },
                          expression: "addForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { prop: "code", label: _vm.$t("area.areaNum") } },
                    [
                      _c("Input", {
                        attrs: {
                          size: "large",
                          maxlength: 4,
                          placeholder: _vm.$t("area.areaNumHold"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.addForm.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "code", $$v)
                          },
                          expression: "addForm.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { prop: "groupCall" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", { staticClass: "error-color" }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.$t("updateNewSip.groupCall")) + " "
                        ),
                      ]),
                      _c("i-switch", {
                        staticClass: "margin-right-10",
                        attrs: {
                          "true-value": 1,
                          "false-value": 0,
                          size: "large",
                        },
                        model: {
                          value: _vm.addForm.groupCall,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "groupCall", $$v)
                          },
                          expression: "addForm.groupCall",
                        },
                      }),
                      _c(
                        "Poptip",
                        {
                          attrs: {
                            trigger: "hover",
                            title: _vm.$t("deviceSip.note"),
                            placement: "right-top",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("h4", { staticClass: "call-tip-box" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("updateNewSip.groupCallTip")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c("Icon", {
                            attrs: {
                              type: "md-help-circle",
                              size: "24",
                              color: "#FFB22B",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "detailBackBtn" },
            [
              _c(
                "Button",
                { attrs: { size: "large" }, on: { click: _vm.closeModal } },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("common.ensure")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content_win" },
        [
          _c("modal", {
            ref: "resultModal",
            attrs: { type: _vm.modalType },
            on: { afterComfirm: _vm.closeModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }